<template>
  <div>
    <div class="p-4 sm:p-12 text-center">
      You are about to merge these contacts. You can't undo merging.
    </div>
    <portal to="contact-merge-header">
      <h3 class="text-lg font-medium text-center">Confirm Merge</h3>
      <p class="text-sm mt-2 text-center font-normal text-gray-600 measure mx-auto">
        Are you sure you want to merge these records?
      </p>
    </portal>

    <portal to="contact-merge-back">
      <template #default="{ prevStep, hasPrevStep }">
        <BaseButton :disabled="!hasPrevStep" ghost @click="prevStep"> Back </BaseButton>
      </template>
    </portal>

    <portal to="contact-merge-next">
      <template #default>
        <BaseButton :disabled="loading" primary @click="mergeContacts"> Merge Contacts </BaseButton>
      </template>
    </portal>
  </div>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async mergeContacts() {
      try {
        this.loading = true;

        await this.$store.dispatch(`${this.accountId}:contactMerge/mergeContacts`);

        this.$store.commit(`${this.accountId}:contactMerge/setContactIds`, []);
        this.$store.commit(`${this.accountId}:contactMerge/setSelectedContactIds`, []);
        this.$store.commit(`${this.accountId}:contactMerge/setMasterContactId`, null);
        this.$store.commit(`${this.accountId}:contactMerge/setFormData`, {});

        this.$emit('merged');
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
